import {useGetSolutionDrug, useGetSolutionDrugActivities} from '@/modules/drug-catalog/solutions/api'
import {DrugCatalogItem, EventLog} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  solutionDrug: DrugCatalogItem
  activities?: EventLog[]
}

interface Props extends PropsWithChildren {
  solutionDrug: DrugCatalogItem
}

const SolutionDrugContext = createContext<State>({} as State)

export function SolutionDrugProvider({children, solutionDrug: initialDrug}: Props) {
  const [solutionDrug] = useGetSolutionDrug(initialDrug.id)
  const [activities] = useGetSolutionDrugActivities(initialDrug.id)

  return (
    <SolutionDrugContext.Provider value={{solutionDrug: solutionDrug || initialDrug, activities}}>
      {children}
    </SolutionDrugContext.Provider>
  )
}

export function useSolutionDrugContext() {
  return useContext(SolutionDrugContext)
}
